import { useEffect, useRef, useState } from "react";
import "../../scss/global.scss";
import "./home.scss";
import { gsap } from "gsap-trial";
import { Link } from "react-router-dom";
import axios from "axios";
import { Estate, Unit } from "../../types/estate";
import { cleanSlug, fetchImageData } from "../../helpers/helpers";

const Home: React.FC = () => {
    const revealRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [isUnit, setIsUnit] = useState<boolean | null>(null);
    const [featuredEstate, setFeaturedEstate] = useState<Estate | null>(null);
    const [featuredUnit, setFeaturedUnit] = useState<Unit | null>(null);

    const words = [
        "business",
        "logistics",
        "manufacturer",
        "creativity",
        "industry",
        "engineering",
        "construction",
        "maintenance",
        "storage",
    ];
    const wordRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!wordRef.current) return;
        const wordElements = wordRef.current.children;
        const tl = gsap.timeline({ repeat: -1 });
        Array.from(wordElements).forEach((el, i) => {
            tl.to(el, { opacity: 1, duration: 1, ease: "power2.inOut" }).to(
                el,
                { opacity: 0, duration: 1, ease: "power2.inOut" },
                "+=1"
            );
        });
    }, []);

    useEffect(() => {}, [featuredEstate, featuredUnit]);
    useEffect(() => {
        const timeline = gsap.timeline({});
        timeline
            .fromTo(
                ".copy-wrapper",
                { opacity: 0, y: "0" },
                { opacity: 1, y: "0", duration: 1, ease: "power2.out" }
            )
            .fromTo(
                ".diagonal-wrapper",
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
                {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    duration: 1,
                    ease: "power2.out",
                },
                "<"
            );

        gsap.fromTo(
            ".home-two",
            { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
            {
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                duration: 1.5,
                ease: "power2.out",

                scrollTrigger: {
                    trigger: "home-two",
                    start: "top top",
                },
            }
        );

        const fetchFeaturedEstate = async () => {
            try {
                const response = await axios.get(
                    `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/featured-unit?_embed&slug=featured-unit-estate`
                );
                if (response.data.length > 0) {
                    const estateData = response.data[0];
                    console.log("Estate Data", estateData);

                    const isUnitValue = estateData.acf.boolean;

                    const labelSlug = estateData.acf.label[0]?.post_name;

                    if (labelSlug) {
                        const response2 = await axios.get(
                            `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed&slug=${labelSlug}`
                        );
                        console.log(response2.data[0]);
                        setFeaturedEstate(response2.data[0]);
                    }
                    if (isUnitValue) {
                        const response2 = await axios.get(
                            `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed&slug=${labelSlug}`
                        );

                        if (response2.data.length > 0) {
                            const units = response2.data[0].acf.units;
                            console.log("Units", units);
                            units?.map((unit: Unit) => {
                                if (
                                    cleanSlug(unit.name) ===
                                    cleanSlug(estateData.acf.units_name)
                                ) {
                                    console.log(true);
                                    setFeaturedUnit(unit);
                                    console.log("Unit", unit);
                                }
                            });
                        }
                    }
                } else {
                    setError("Article not found");
                }
            } catch (err) {
                setError("Failed to load article");
            } finally {
                setLoading(false);
            }
        };
        fetchFeaturedEstate();
    }, []);

    useEffect(() => {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: revealRef.current,
                start: "top bottom",
                end: "center center",
                scrub: true,
            },
        });

        timeline
            .fromTo(revealRef.current, { scale: 0 }, { scale: 1, duration: 1 })
            .fromTo(
                ".opacity-anim",
                {
                    opacity: 0,
                },
                { opacity: 1, duration: 1 },
                "<0.5"
            );
        return () => {
            timeline.kill();
        };
    }, []);

    return (
        <>
            <div className="contain-wrapper">
                <div className="home-one contain">
                    <div className="copy-wrapper">
                        <h1>
                            The right space <br />
                            for your business
                        </h1>
                        <Link
                            target="_top"
                            className="volt-button view-portfolio"
                            to={"/portfolio"}
                        >
                            <p>View All Properties</p>
                        </Link>
                    </div>
                    <div className="diagonal-wrapper" ref={revealRef}>
                        <div className="diagonal">
                            <div className="parallelogram"></div>
                            <div className="parallelogram-image">
                                <video
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    src="https://player.vimeo.com/progressive_redirect/playback/1044684225/rendition/720p/file.mp4?loc=external&signature=e089b277317b8b207187b25a2754f03b87744f663fb3dced737ee760ed9e1e82"
                                />
                            </div>
                        </div>
                        <div className="section">
                            <h3
                                style={{ whiteSpace: "nowrap", width: "350px" }}
                            >
                                Space for your{" "}
                                <span
                                    ref={wordRef}
                                    style={{
                                        position: "relative",
                                        width: "fit-content",
                                    }}
                                >
                                    {words.map((word, index) => (
                                        <span
                                            key={index}
                                            style={{
                                                position: "absolute",
                                                opacity: 0,
                                                paddingLeft: "7px",
                                            }}
                                        >
                                            {word}
                                        </span>
                                    ))}
                                </span>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="home-two contain">
                    <p>About Us</p>
                    <h3>
                        Space Industrial specialises in providing modern and
                        efficient warehouse space in the urban locations you
                        need for your business
                    </h3>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="home-three contain">
                    <p>Featured Property</p>
                    <div className="featured-wrapper">
                        {featuredUnit ? (
                            <div className="featured-section">
                                <div
                                    className="featured-image"
                                    style={{
                                        backgroundImage: `url(${featuredUnit.images[0].image})`,
                                    }}
                                >
                                    <p>{featuredUnit?.let_status}</p>
                                </div>
                                <div className="featured-info-wrapper">
                                    <div className="inline-copy featured-info">
                                        <img
                                            src="/ui/logo.svg"
                                            className="logo"
                                            alt="logo"
                                        />
                                        <h3>{featuredUnit?.name}</h3>
                                        <h4 className="volt">/</h4>
                                        <h4 dangerouslySetInnerHTML={{ __html: featuredUnit?.postcode || '' }}></h4>
                                        <h4 className="volt">/</h4>
                                        <h4>{featuredUnit?.sq_ft}</h4>
                                    </div>
                                    <Link
                                        target="_top"
                                        to={`/portfolio/${
                                            featuredEstate?.slug
                                        }/${cleanSlug(featuredUnit?.name)}`}
                                        className="inline-copy featured-link"
                                    >
                                        <p>View property</p>
                                        <div className="parallelogram-small"></div>
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            featuredEstate && (
                                <div className="featured-section">
                                    <div
                                        className="featured-image"
                                        style={{
                                            backgroundImage: `url(${
                                                featuredEstate._embedded?.["wp:featuredmedia"]?.[0]?.link || 
                                                featuredEstate.acf?.image
                                            })`,
                                        }}
                                    >
                                        <p>{featuredEstate?.acf.let_status}</p>
                                    </div>
                                    <div className="featured-info-wrapper">
                                        <div className="inline-copy featured-info">
                                            <img
                                                src="/ui/logo.svg"
                                                className="logo"
                                                alt="logo"
                                            />
                                            <h3>{featuredEstate?.acf.name}</h3>
                                            <h4 className="volt">/</h4>
                                            <h4 dangerouslySetInnerHTML={{ __html: featuredEstate?.acf.postcode || '' }}></h4>
                                            <h4 className="volt">/</h4>
                                            <h4>{featuredEstate?.acf.sq_ft}</h4>
                                        </div>
                                        <Link
                                            target="_top"
                                            to={`/portfolio/${featuredEstate.slug}`}
                                            className="inline-copy featured-link"
                                        >
                                            <p>View property</p>
                                            <div className="parallelogram-small"></div>
                                        </Link>
                                    </div>
                                </div>
                            )
                        )}
                        <Link
                            target="_top"
                            to={"/portfolio"}
                            className="copy-wrapper"
                            ref={revealRef}
                        >
                            <img
                                className="arc"
                                src="../ui/arc.svg"
                                alt="arc"
                            />
                            <img
                                className="arc"
                                src="../ui/arc.svg"
                                alt="arc"
                            />
                            <img
                                className="arc"
                                src="../ui/arc.svg"
                                alt="arc"
                            />
                            <img
                                className="arc"
                                src="../ui/arc.svg"
                                alt="arc"
                            />
                            <h1 className="opacity-anim">
                                Find the right
                                <br />
                                space for you.
                            </h1>
                            <div className="copy opacity-anim">
                                <p>View all properties</p>
                                <div className="parallelogram-small"></div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;
